import {
  GET_NEW_CLIENTS_SUCCESS,
  GET_NEW_CLIENTS_FAIL,
  GET_SELECTED_NEW_CLIENTS_SUCCESS,
  GET_SELECTED_NEW_CLIENTS_FAIL,
  SHOW_LOADING,
  HIDE_LOADING,
} from "./actionTypes"

const INIT_STATE = {
  period: [],
  managers: [],
  years: [],
  months: [],
  new_clients: [],
  loading: false,
}

const stats = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NEW_CLIENTS_SUCCESS:
      return {
        ...state,
        period: action.payload[0],
        managers: action.payload[1],
        years: action.payload[2],
        months: action.payload[3],
        new_clients: action.payload[4],
      }
    case GET_NEW_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_SELECTED_NEW_CLIENTS_SUCCESS:
      return {
        ...state,
        new_clients: action.payload,
      }
    case GET_SELECTED_NEW_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}

export default stats